<template>
    <v-app id="login" class="login-background">
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs3>
                    <v-card>
                        <v-card dark color="primary">
                            <v-card-text>
                                <v-toolbar-title>Login</v-toolbar-title>
                            </v-card-text>
                        </v-card>

                        <v-flex xs12>
                            <v-layout justify-center class="mt-3">
                                <v-btn-toggle
                                    mandatory
                                    v-model="loginMode"
                                    class="toggle-button-group"
                                >
                                    <v-btn
                                        flat
                                        value="windows"
                                        class="toggle-button"
                                    >
                                        UTA Windows Login
                                    </v-btn>
                                    <v-btn
                                        flat
                                        value="plane"
                                        class="toggle-button"
                                    >
                                        Custom Login
                                    </v-btn>
                                </v-btn-toggle>
                            </v-layout>
                        </v-flex>
                        <v-card-text class="pb-2">
                            <v-form>
                                <v-text-field
                                    prepend-icon="mdi-account"
                                    name="username"
                                    label="User Name"
                                    type="text"
                                    ref="username"
                                    v-model="username"
                                    :rules="[rules.required]"
                                ></v-text-field>
                                <v-text-field
                                    prepend-icon="mdi-lock"
                                    autocomplete
                                    name="password"
                                    label="Password"
                                    id="password"
                                    type="password"
                                    ref="password"
                                    v-model="password"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-layout column>
                                <v-btn
                                    class="mb-3"
                                    dark
                                    :loading="loggingIn"
                                    color="green"
                                    v-on:click="login()"
                                    >Login</v-btn
                                >
                            </v-layout>
                        </v-card-actions>

                        <v-card-text v-if="invalidLogin" class="pt-0">
                            <p class="text-danger">
                                {{ loginError }}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-app>
</template>

<script>
import paths from "../router/paths";

export default {
    data: () => ({
        username: "",
        password: "",
        name: "",
        invalidLogin: false,
        loggingIn: false,
        loginMode: "windows",
        loginError: "",
        pages: [],

        rules: {
            required: (value) => !!value || "Required.",
        },
    }),
    async created() {
        window.addEventListener("keyup", (e) => this.onKeyPressed(e));

        await this.$store.dispatch("authentication/AUTH_LOGOUT");

        this.loadPages();

        const loginMode = localStorage.getItem("login-mode");

        this.loginMode = loginMode ? loginMode : "windows";
    },
    destroyed() {
        window.removeEventListener("keyup", (e) => this.onKeyPressed(e));
    },
    methods: {
        onKeyPressed(e) {
            if (e.keyCode == 13) {
                this.login();
            }
        },
        loadPages() {
            this.pages = paths;
        },
        async login() {
            if (
                !this.$refs.username.validate(true) ||
                !this.$refs.password.validate(true)
            )
                return;

            this.loggingIn = true;

            this.$Progress.start();

            const username = this.getUsername();

            try {
                const user = await this.$store.dispatch(
                    "authentication/AUTH_REQUEST",
                    {
                        username: username,
                        password: this.password,
                        windowsLogin: this.loginMode == "windows",
                    },
                );

                localStorage.setItem("login-mode", this.loginMode);

                this.$router.push({
                    name: this.getRedirectLink(user),
                    params: this.$route.query.params,
                });

                this.$Progress.finish();
            } catch (error) {
                this.loggingIn = false;

                this.$Progress.finish();

                this.invalidLogin = true;
                this.loginError = error;
            }
        },
        getUsername() {
            if (this.loginMode != "windows") return this.username;

            return this.username.includes("@utaw.org")
                ? this.username
                : this.username + "@utaw.org";
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        getRedirectLink(user) {
            return "UtaDashboard";

            // if (!this.isAdmin()) {
            //     const page = this.pages.find(
            //         (path) =>
            //             !path.path.includes(":") &&
            //             user.claims.includes(path.name),
            //     );

            //     return page ? page.name : user.claims[0];
            // }

            // return this.$route.query.redirect
            //     ? this.$route.query.redirect
            //     : "Accounts";
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}

.login-background {
    background-image: url(https://utaw.blob.core.windows.net/images/logo+uta11.png) !important;
    /* height: 100% !important; */
    background-position: right 50% bottom 95% !important;
    background-repeat: no-repeat !important;
    background-size: 10% !important;
}
</style>
